import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'navigation_tree_ux-categories_menu_button-view';
/**
 * Track viewing the button that opens the categories menu
 */
export function trackNavigationTreeUxCategoriesMenuButtonView() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
